import { AxiosRequestConfig, AxiosResponse } from 'axios';
import client from 'api/client';
import { PaymentPayload } from '../models/payload';

export function post(
    payload: PaymentPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ url: string }>> {
    return client.post<{ url: string }>('/payments', payload, customConfig);
}

export function paymentsList(
    candidateId?: number,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse> {
    const url = candidateId ? `/payments_list/${candidateId}` : `/payments_list`;
    return client.get<{ url: string }>(url, customConfig);
}

export function paywallStatus(customConfig?: AxiosRequestConfig): Promise<AxiosResponse> {
    const url = '/paywall_status';
    return client.get<{ url: string }>(url, customConfig);
}
